var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "show-products-carousel-component ti-fs-regular" },
    [
      _c("h1", { staticClass: "title mt-80 mb-35" }, [
        _vm._v(_vm._s(_vm.stepSelectionText)),
      ]),
      _vm._v(" "),
      _vm.productRecommendationsMessage
        ? _c("div", [_vm._v(" " + _vm._s(_vm.productRecommendationsMessage))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "row no-gutters ti-sliders ti-bg-color-white js-finder-products",
          attrs: { "data-swiper-carousels": "" },
        },
        [
          _c(
            "div",
            { staticClass: "pb-72 pb-md-100 col-12 ti-sliders-content" },
            [
              _c(
                "div",
                {
                  ref: "swiper",
                  class: `col-12 swiper ti-swiper-container ti-swiper-container-pagination ti-disable-swiper-imag es slider-product-watch-finder-results`,
                  style: _vm.carouselStyle,
                  attrs: {
                    "data-swiper-slider-init": "",
                    "data-swiper-pd-slider": "watch-finder-results",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "swiper-wrapper" },
                    _vm._l(_vm.products, function (product, i) {
                      return _c(
                        "div",
                        {
                          key: "product-" + i,
                          staticClass: "swiper-slide",
                          attrs: { "data-slider-position": i },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "product-tile product",
                              attrs: { "data-pid": product.id },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "ti-images-container",
                                  attrs: { "data-swiper-slider": product.id },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "ti-images-link",
                                      attrs: {
                                        href: product.custom.productLink,
                                      },
                                    },
                                    [
                                      _c("img", {
                                        ref: "image",
                                        refInFor: true,
                                        staticClass:
                                          "ti-picture-img ti-bg-color-gradient-gray w-100 lazyload lazyload img-fluid loaded",
                                        attrs: {
                                          alt: product.images.Shadow[0][
                                            "normal_square"
                                          ].alt,
                                          loading: "lazy",
                                          "data-image-product": "",
                                          src: product.images.Shadow[0][
                                            "normal_square"
                                          ].url,
                                        },
                                        on: { load: _vm.setCarouselStyle },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "icon-heart-tile",
                                      attrs: {
                                        "data-icon-linked-products-wishlist":
                                          "",
                                        "data-add-to-wishlist": "",
                                        "data-href": product.custom.wishlistUrl,
                                        "aria-label": _vm.heartBtnText,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addToWishlist()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "svg-wrapper svg-icon-heart",
                                        staticStyle: { width: "24px" },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.getIcon("icon-heart")
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "ti-tile-body px-16",
                                  attrs: { "data-tile-body-bottom": "" },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "ti-product-link d-flex ti-fs-13",
                                      attrs: {
                                        href: product.custom.productLink,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(product.productName) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "price ti-product-price font-weight-bold ti-fs-13",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "ti-product-price-inner",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "ti-price-sales" },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    product.price.sales
                                                      .formatted
                                                  ) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row no-gutters" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 ti-product-labels ti-fs-11 d-flex",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "ti-product-label" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  product.custom.movement
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "ti-product-label" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  product.custom.productLinksMsg
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "swiper-button-next",
                    attrs: { "aria-label": _vm.nextBtnText },
                  }),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "swiper-button-prev",
                    attrs: { "aria-label": _vm.prevBtnText },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass:
                      "swiper-product-pagination-watch-finder-results",
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("StepsBarComponent", { attrs: { isResultsPage: true } }),
      _vm._v(" "),
      _c("NavButtonsComp", { attrs: { isResultsPage: true } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "ti-toast-section d-flex justify-content-center align-items-center position-fixed",
        attrs: { "aria-live": "polite", "aria-atomic": "true" },
      },
      [
        _c(
          "div",
          {
            staticClass: "toast ti-toast ti-bg-color-white hide",
            attrs: {
              id: "toast-wishlist-toast",
              role: "alert",
              "aria-live": "assertive",
              "aria-atomic": "true",
            },
          },
          [_c("div", { staticClass: "toast-body font-weight-normal" })]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }